import { useGeolocation } from "@/contexts/GeolocationContext";

// Re-export the type for backwards compatibility
export type { GeolocationData } from "@/contexts/GeolocationContext";

// Backwards compatible wrapper
export function useIPGeolocation() {
  return useGeolocation();
}
